import type { FC } from 'react'

import { ChatMediaType } from '@/modules/chatting/types.ts'
import { classNames } from '@/utils/helpers.ts'

const options = [
  {
    label: 'All',
    value: ChatMediaType.All,
  },
  {
    label: 'Unlocked',
    value: ChatMediaType.Unlocked,
  },
  {
    label: 'Photos',
    value: ChatMediaType.Photo,
  },
  {
    label: 'Videos',
    value: ChatMediaType.Video,
  },
  {
    label: 'Audios',
    value: ChatMediaType.Audio,
  },
]

interface Props {
  onSelect: (type: ChatMediaType) => void
  selected: ChatMediaType
}

export const ChatGalleryFilters: FC<Props> = ({ onSelect, selected }) => {
  return (
    <div className="flex items-center px-3">
      {options.map(({ value, label }) => (
        <div
          key={value}
          onClick={() => onSelect(value)}
          className={classNames(
            'mr-2 cursor-pointer rounded-[100px] px-3 py-1 text-sm font-medium text-text-default transition duration-200 last:mr-0',
            {
              'bg-primary-500 text-white dark:bg-primary-500':
                selected === value,
              'bg-secondary-50 hover:bg-secondary-200 dark:bg-secondary-600 dark:hover:bg-primary-800':
                selected !== value,
            },
          )}
        >
          {label}
        </div>
      ))}
    </div>
  )
}
